import { render, staticRenderFns } from "./MintalMesPrdSmeltingResistanceBeforeIronList.vue?vue&type=template&id=f3f5af3a&"
import script from "./MintalMesPrdSmeltingResistanceBeforeIronList.vue?vue&type=script&lang=js&"
export * from "./MintalMesPrdSmeltingResistanceBeforeIronList.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports